import React from "react";
import DeleteButtonWithBg from "app/assets/icons/DeleteButtonBg";
import PDFIcon from "app/assets/icons/PDFIcon";

interface Props {
  fileName: string;
  onDelete?: () => void;
}

const BankStatementView: React.FC<Props> = ({
  fileName,
  onDelete = () => {},
}) => {
  return (
    <>
      <div className={`w-full bg-[#F3F3F3] rounded-[12px] p-3 my-2`}>
        <div className="flex gap-2 justify-between items-center">
          <div className="flex w-[90%] ">
            <div className="w-[10%] flex justify-start items-center">
              <PDFIcon />
            </div>
            <div className="text-[14px] w-[90%]  break-words  truncate  overflow-hidden whitespace-nowrap text-ellipsis text-[#000000] font-Mulish font-normal">
              {fileName}
            </div>
          </div>
          <div className="w-[10%] flex justify-center items-center">
            <DeleteButtonWithBg className="cursor-pointer" onClick={onDelete} />
          </div>
        </div>
      </div>
    </>
  );
};

export default BankStatementView;
